import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getSamparkDispositions,
  samparkDispositionListSuccessful,
  samparkDispositionAddSuccessful,
  isModelVisible,
} from "./samparkDispositionSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
} from "react-icons/ri";

function* getSamparkDisposition({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "" && k !== null && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/samparkdisposition/", params);
    yield put(samparkDispositionListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddSamparkDisposition({ payload }) {
  try {
    if (payload.id == 0 || payload.id === undefined) {
      const response = yield call(postAdd, "/masters/samparkdisposition/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sampark Disposition added successfully!
              </p>
            </div>
          ),
        });
        yield put(getSamparkDispositions({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to add Sampark Disposition. Please try again!
              </p>
            </div>
          ),
        });
      }
    } else {
      const response = yield call(
        postEdit,
        "/masters/samparkdisposition/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sampark Disposition edited successfully!
              </p>
            </div>
          ),
        });
        yield put(getSamparkDispositions({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Sampark Disposition. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            {error?.response?.data?.error || "Sorry! Getting server side issue!"}
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteSamparkDisposition({ payload }) {
  var dispositionID = payload;
  try {
    const response = yield call(
      postDelete,
      "/masters/samparkdisposition/" + dispositionID
    );

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sampark Disposition deleted successfully!
            </p>
          </div>
        ),
      });
      yield put(getSamparkDispositions({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Unable to delete Sampark Disposition. Please try again!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

export function* watchGetSamparkDispositions() {
  yield takeEvery("samparkDisposition/getSamparkDispositions", getSamparkDisposition);
}

export function* watchSamparkDispositionAdd() {
  yield takeEvery("samparkDisposition/samparkDispositionAdd", AddSamparkDisposition);
}

export function* watchSamparkDispositionDelete() {
  yield takeEvery("samparkDisposition/samparkDispositionDelete", DeleteSamparkDisposition);
}

function* samparkDispositionSaga() {
  yield all([
    fork(watchGetSamparkDispositions),
    fork(watchSamparkDispositionAdd),
    fork(watchSamparkDispositionDelete),
  ]);
}

export default samparkDispositionSaga;
